import React from 'react';
import Text from 'components/Text/Text';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './NoResultsFound.module.scss';

interface INoResultsFound {
	isVisible: boolean;
}

const NoResultsFound: React.FC<INoResultsFound> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="NoResultsFound">
			<div className={style.iconWrapper}>
				<svg>
					<use xlinkHref={`${breadcrumbs}#sadFace`} />
				</svg>
			</div>
			<div className={style.text}>
				<Text
					className={style.title}
					translationNameSpace="listing"
					translationKey="noResultsFoundTitle"
					size="xxl"
				/>
				<Text
					className={style.description}
					translationNameSpace="listing"
					translationKey="noResultsFoundDescription"
				/>
			</div>
		</div>
	);
};

export default NoResultsFound;
